export default [
    {
        id: 1,
        name_ca: 'Desconegut',
        name_es: 'Desconocido',
        name_en: 'Unknown'
    }, {
        id: 2,
        name_ca: 'Baix',
        name_es: 'Bajo',
        name_en: 'Low'
    }, {
        id: 3,
        name_ca: 'Mitjà',
        name_es: 'Medio',
        name_en: 'Average'
    }, {
        id: 3,
        name_ca: 'Sorollós',
        name_es: 'Ruidoso',
        name_en: 'Noisy'
    }, {
        id: 3,
        name_ca: 'Molt sorollós',
        name_es: 'Muy ruidoso',
        name_en: 'Very noisy'
    }
]





// WEBPACK FOOTER //
// ./src/options/noise_levels.js